import React from 'react';
import JuniorScience2023 from 'views/JuniorScience2023';

const AccountGeneralPage = () => {
  return <JuniorScience2023 />;
};

export default AccountGeneralPage;
